import sdk, { FetchError } from "@repo/api-sdk";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { customersQueryKeys } from "./queryKeys";

/**
 * The profile is the app's source of truth for "is anyone logged in", so it is
 * asked on every page load - including the login page. With no session token
 * there is nothing to ask: the request can only come back 401, and every one of
 * those is a red line in the browser console and a failed call in the network
 * log of a perfectly healthy logged-out visit. So answer 401 locally instead.
 *
 * It is the same `FetchError` the SDK would have thrown, so everything that
 * reads the failure (the auth route's redirect, `AuthRouterObserver`, the
 * analytics reset) behaves exactly as it does for a real 401. A token that is
 * present but no longer valid still goes to the server and still comes back 401.
 */
async function fetchProfile() {
  if (!(await sdk.client.getToken())) {
    throw new FetchError("Unauthorized", "Unauthorized", 401);
  }
  return sdk.store.customer.profile();
}

export function profileQuery() {
  return queryOptions({
    queryKey: customersQueryKeys.profile(),
    queryFn: fetchProfile,
    retry: false,
    staleTime: 5 * 60 * 1000
  });
}

export function useProfile() {
  return useQuery({
    ...profileQuery()
  });
}
